module.exports = __webpack_public_path__ + "static/media/logoorange.5c2b21d5.png";